(function () {
  'use strict';

  function init() {
    var bar = document.querySelector('[data-sticky-atb]');
    if (!bar) return;

    var productSection = document.querySelector('.main-product-page');
    if (!productSection) return;

    var atcGroup = productSection.querySelector('.product-form__controls-group--submit');
    var header = document.getElementById('shopify-section-header');
    var desktopQuery = window.matchMedia('(min-width: 768px)');

    /* --- Visibility ------------------------------------------------------ */

    var scrollRaf = null;

    function headerOffset() {
      if (!header) return 0;
      return Math.max(header.getBoundingClientRect().bottom, 0);
    }

    function updateVisibility() {
      var sentinel = desktopQuery.matches ? productSection : atcGroup || productSection;
      var sentinelPassed = sentinel.getBoundingClientRect().bottom <= headerOffset();
      bar.classList.toggle('is-visible', sentinelPassed);
    }

    function onScroll() {
      if (scrollRaf) return;
      scrollRaf = requestAnimationFrame(function () {
        scrollRaf = null;
        updateVisibility();
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    updateVisibility();

    /* --- Add to bag proxy ------------------------------------------------ */

    var sourceButton = productSection.querySelector('[data-add-to-cart]');
    var stickyButton = bar.querySelector('[data-sticky-atb-submit]');
    var stickyButtonText = bar.querySelector('[data-sticky-atb-submit-text]');

    function syncSubmitButton() {
      if (!sourceButton || !stickyButton) return;
      var sourceText = sourceButton.querySelector('[data-add-to-cart-text]');
      if (sourceText && stickyButtonText) {
        stickyButtonText.textContent = sourceText.textContent.trim();
      }
      stickyButton.disabled = sourceButton.disabled;
      if (sourceButton.disabled) {
        stickyButton.setAttribute('aria-disabled', 'true');
      } else {
        stickyButton.removeAttribute('aria-disabled');
      }
    }

    if (sourceButton && stickyButton) {
      stickyButton.addEventListener('click', function () {
        sourceButton.click();
      });

      var observer = new MutationObserver(syncSubmitButton);
      observer.observe(sourceButton, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-label'],
        childList: true,
        subtree: true,
        characterData: true
      });
      syncSubmitButton();
    }

    /* --- Price updates on variant change --------------------------------- */

    var priceEl = bar.querySelector('[data-sticky-atb-price]');
    var compareEl = bar.querySelector('[data-sticky-atb-compare]');
    var saveEl = bar.querySelector('[data-sticky-atb-save]');
    var worthPrice = parseInt(bar.getAttribute('data-worth-price'), 10) || 0;
    var enableWorth = bar.getAttribute('data-enable-worth') === 'true';

    function formatMoney(cents) {
      if (window.theme && theme.Currency && theme.moneyFormat) {
        return theme.Currency.formatMoney(cents, theme.moneyFormat, 0);
      }
      return '£' + Math.round(cents / 100);
    }

    function updatePrice(variant) {
      if (!variant || !priceEl) return;

      priceEl.innerHTML = formatMoney(variant.price);
      bar.classList.remove('sticky-atb--on-sale', 'sticky-atb--on-worth');

      var onSale = variant.compare_at_price > variant.price;
      var onWorth = enableWorth && !onSale && worthPrice > variant.price;

      if (compareEl) {
        if (onSale && enableWorth) {
          compareEl.innerHTML = 'Was&nbsp;' + formatMoney(variant.compare_at_price);
          compareEl.removeAttribute('hidden');
        } else if (onWorth) {
          compareEl.innerHTML = 'Worth&nbsp;' + formatMoney(worthPrice);
          compareEl.removeAttribute('hidden');
        } else {
          compareEl.innerHTML = '';
          compareEl.setAttribute('hidden', '');
        }
      }

      if (saveEl) {
        if (onSale && enableWorth) {
          saveEl.innerHTML = 'Save&nbsp;' + formatMoney(variant.compare_at_price - variant.price);
          bar.classList.add('sticky-atb--on-sale');
        } else if (onWorth) {
          saveEl.innerHTML = 'Save&nbsp;' + formatMoney(worthPrice - variant.price);
          bar.classList.add('sticky-atb--on-worth');
        } else {
          saveEl.innerHTML = '';
        }
      }
    }

    if (window.jQuery) {
      window.jQuery(document).on('variantPriceChange variantChange', function (evt) {
        if (evt.variant) {
          updatePrice(evt.variant);
        }
        syncSubmitButton();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
